import AppApi from "../api/AppApi";
import AppStore from "./AppStore";

class MainApp {
  store: AppStore;
  api: AppApi;

  constructor() {
    this.store = new AppStore();
    this.api = new AppApi(this.store);
  }
}

export default MainApp;
